var a=function(a,r){return a.has(r)};export{a as default};
//# sourceMappingURL=_cacheHas.js.map
